import Vue from "vue";
import TranslationService from "../../services/TranslationService";

const NotificationService = require("../../services/NotificationService");

export default Vue.component("charity", {

    props: {
        template:
            {
                type: String,
                default: "#vue-charity"
            },
        charityList:
            {
                type: Array,
                default: null
            }
    },

    data()
    {
        return {
            isChecked: false,
            activeCharity: null,
            basketItemWithCharity: null,
            isLoading: false
        };
    },

    created()
    {
        this.$options.template = this.template;
    },

    computed: {
        basketItems()
        {
            return this.$store.state.basket.items;
        },
        amountTxt()
        {
            return TranslationService.translate("GonserDT::Template.checkoutConfirmDonation", {
                cname: this.activeCharity.name,
                amount: this.activeCharity.donationAmount + ".00"
            } );
        }
    },

    methods: {

        getProperty(item)
        {
            if (item.variation.data.properties)
            {
                for (const property of item.variation.data.properties)
                {
                    if (parseInt(property.property.id) === parseInt(this.activeCharity.propertyId))
                    {
                        return {
                            "item": item,
                            "property": property.property
                        };
                    }
                }
            }
            return null;
        },

        getItemAndProperty()
        {
            if (this.activeCharity)
            {
                for (const item of this.basketItems)
                {
                    const itemProp = this.getProperty(item);

                    if (itemProp !== null)return itemProp;
                }
            }
            return null;
        },

        addToBasket(basketObject, withCharity)
        {
            return new Promise((resolve, reject) =>
            {
                this.$store.dispatch("addBasketItem", basketObject).then(
                    response =>
                    {
                        document.dispatchEvent(new CustomEvent("afterBasketItemAdded", { detail: basketObject }));
                        if (withCharity)
                        {
                            this.basketItemWithCharity = response.data;
                        }
                        this.$store.commit("setIsAddToBasketLoading", 0);
                        resolve();
                    },
                    error =>
                    {
                        this.$store.commit("setIsAddToBasketLoading", 0);
                        reject(error);
                    });
            });
        },

        updateBasketItem(basketItem)
        {
            return new Promise((resolve, reject) =>
            {
                this.$store.dispatch("updateBasketItemQuantity", {
                    id: basketItem.id,
                    variationId: basketItem.variation.id,
                    quantity: basketItem.quantity - 1
                }).then(
                    response =>
                    {
                        document.dispatchEvent(new CustomEvent("afterBasketItemQuantityUpdated", { detail: basketItem }));
                        this.$store.commit("setIsAddToBasketLoading", 0);
                        resolve();
                    },
                    error =>
                    {
                        this.$store.commit("setIsAddToBasketLoading", 0);
                        reject();
                    });
            });
        },

        removeBasketItem(basketItem)
        {
            return new Promise((resolve, reject) =>
            {
                this.$store.dispatch("removeBasketItem", basketItem.id).then(
                    response =>
                    {
                        document.dispatchEvent(new CustomEvent("afterBasketItemRemoved", {
                            detail: basketItem
                        }));
                        resolve();
                    },
                    error =>
                    {
                        reject();
                    });
            });
        },

        addToBasketWithCharity()
        {
            const itemProperty = this.getItemAndProperty();

            const basketObject = { variationId: itemProperty["item"].variationId, quantity: 1, basketItemOrderParams: [{ propertyId: itemProperty["property"].id, type: itemProperty["property"].valueType, name: itemProperty["property"].names.name, value: itemProperty["property"].isOderProperty }], totalOrderParamsMarkup: itemProperty["property"].surcharge };

            this.isLoading = true;

            const waitForAdd = this.addToBasket(basketObject, true);

            let waitForBasketAction = null;

            waitForAdd.then(res =>
            {

                if (itemProperty["item"].quantity > 1)
                {
                    waitForBasketAction = this.updateBasketItem(itemProperty["item"]);
                }
                else
                {
                    waitForBasketAction = this.removeBasketItem(itemProperty["item"]);
                }

                waitForBasketAction.then(() =>
                {
                    NotificationService.success(
                        TranslationService.translate("GonserDT::Template.checkoutAddedCharity")).closeAfter(6000);
                    this.isLoading = false;
                },
                error =>
                {
                    this.isLoading = false;
                });

            }).catch(error =>
            {
                this.isLoading = false;
            });
        },

        removeFromBasket(basketItem)
        {
            if (basketItem !== null)
            {
                this.isLoading = true;

                const waitForAdd = this.addToBasket({
                    variationId:   basketItem.variationId,
                    quantity   :   basketItem.quantity
                }, false);

                waitForAdd.then(
                    res =>
                    {
                        this.removeBasketItem(basketItem).then(() =>
                        {
                            NotificationService.success(
                                TranslationService.translate("GonserDT::Template.checkoutRemovedCharity")
                            ).closeAfter(4000);
                            this.isLoading = false;
                        },
                        error =>
                        {
                            this.isLoading = false;
                        });
                    },
                    error =>
                    {
                        this.isLoading = false;
                    });
            }
        },

        findActiveCharity()
        {
            this.basketItemWithCharity = null;
            this.activeCharity = null;
            let isCharityItemInBasket = false;

            if (this.charityList)
            {
                for (const charity of this.charityList)
                {
                    if (this.activeCharity === null)
                    {
                        for (const categoryId of charity.activeForCategories)
                        {
                            for (const item of this.basketItems)
                            {
                                for (const defaultCategory of item.variation.data.defaultCategories)
                                {
                                    if (categoryId === defaultCategory.id)
                                    {
                                        this.activeCharity = charity;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            for (const item of this.basketItems)
            {
                for (const orderParam of item.basketItemOrderParams)
                {
                    if (this.activeCharity !== null)
                    {
                        if (parseInt(orderParam.propertyId) === parseInt(this.activeCharity.propertyId))
                        {
                            isCharityItemInBasket = true;
                            this.basketItemWithCharity = item;
                        }
                    }
                }
            }
            this.isChecked = isCharityItemInBasket;
        }
    },

    watch: {
        basketItems()
        {
            this.findActiveCharity();
        },

        isChecked()
        {
            if (this.isChecked && this.basketItemWithCharity === null)
            {
                this.addToBasketWithCharity();
            }
            else if (!this.isChecked)
            {
                this.removeFromBasket(this.basketItemWithCharity);
            }
        }
    }
});
